import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import RentalTabs from "../tabs/tabs";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const RentalAccordion = {
    current: null,

    init() {
        this.el = $('[module="rental"].wrapper ');
        if (!this.el.length) return;

        this.headers = this.el.find('a.accordionHeader');
        this.setCurrent(window.location.pathname);
        // this.initFooter(this.el);
        this.bind();
    },

    setCurrent(url) {
        this.current = this.headers.filter('[href="' + url + '"]');

        if (this.current.length === 0) {
            this.current = this.el.find('a.tab:first-child');
        }

        setTimeout(() => {
            this.scrollToTop(this.current, 0);
        }, 100)
    },

    bind() {
        this.el.find('a.accordionHeader').on('click', (evt) => this.onClick(evt));
    },

    initFooter(el) {
        const footer = this.footer = el.find('section.footer');
        console.log(footer)

        ScrollTrigger.create({
            id: 'footerPin',
            trigger: footer,
            pin: true,
            pinSpacing: false,
            start: "top 100px",
            endTrigger: el,
            end: "bottom bottom",
            invalidateOnRefresh: true,
            markers: true
        });
    },

    onClick(evt) {
        evt.preventDefault();
        const header = $(event.currentTarget);

        if (header.is(".active")) {
            const section = header.next('[module="rental"][section]').removeClass('active');
            gsap.to(section, {height: 0});
            header.removeClass('active')
            return;
        }

        header.addClass('active').siblings().removeClass('active');

        let url = header.attr('href');
        const hash = rentalHash ? `?hash=${rentalHash}` : ''
        this.direction = header.attr('order') > this.current.attr('order') ? 1 : -1
        this.current = header;

        history.pushState({url: url, direction: this.direction}, '', url + hash)
        Rental.load(url, null, this.direction);
    },

    setActive(url, direction, response) {
        this.current = this.headers.filter('[href="' + url + '"]');
        this.current.addClass('active').siblings().removeClass('active');
        const html = $('<div>').hide().empty().html(response);
        const oldSection = this.el.find('[module="rental"][section]');
        const newSection = html.find('[module="rental"][section]').insertAfter(this.current);

        this.el.attr('current', newSection.attr('section'));

        gsap.set(newSection, {height: "auto"});
        gsap.timeline({
            onComplete: () => {
                oldSection.remove();
            }
        })
            .to(oldSection, {height: 0}, 0)
            .from(newSection, {height: 0, clearProps: true}, 0)

        const activeHeight = oldSection.outerHeight();
        const shift = direction > 0 ? activeHeight : 0;

        this.scrollToTop(this.current, shift);

    },

    updateData() {
        if(!this.headers) return;

        this.headers.each((i, el) => {
            const key = $(el).attr('key');
            const val = RentalTabs.el.find('[key="' + key + '"] footer').text();
            $(el).find('footer').text(val);
        })

        const vehicle = RentalTabs.el.find('[key="name"]').text();
        this.headers.filter('[key="vehicle"]').find('.vehicle').text(vehicle);
    },

    scrollToTop(current, shift) {
        const y = current.offset().top - shift;
        const body = $('body');
        const yOffset = parseInt(body.css('--fixedHeaderHeight')) + parseInt(body.css('--blockPadding'));
        // console.log(current, y, shift, yOffset)
        gsap.to(window, {scrollTo: {y: y, offsetY: yOffset}})
    },

}

export default RentalAccordion;